import {
  CLEAR_DATA,
  UPDATE_DATA
} from 'apps/action_types';
export const update = (data: any) => {
  return {
    type: UPDATE_DATA,
    payload: data,
  };
};
export const clear = () => {
  return {
    type: CLEAR_DATA,
    payload: {},
  };
};

export const data = {
  update: update,
  clear: clear
}

export const dataAction = data;
